module.exports = __webpack_public_path__ + "static/media/male-green-v3.4bb3043a.svg";